
export default {
  props: {
    length: {
      type: Number,
      default: 0,
    },
    maxlength: {
      type: Number,
      required: true,
    },
  },
};
